module.exports = __webpack_public_path__ + "static/media/A_wa_ui.c209815c.png";